// extracted by mini-css-extract-plugin
export var link = "_c-0";